"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { ArrowRight } from "lucide-react";
import { FieldDiffValue } from "@/components/molecules/FieldDiffValue/FieldDiffValue";
import type { PropertyShared } from "../sharedFieldsToApply";
import { useAssociateFieldsStep } from "./useAssociateFieldsStep";
import { CheckableFieldRow } from "./CheckableFieldRow";
export function AssociateFieldsStep(t0) {
  const $ = _c(24);
  const {
    property,
    listingId
  } = t0;
  const t = useTranslations("modules.portfolio.associateListingToUnit.stepper");
  let t1;
  if ($[0] !== listingId || $[1] !== property) {
    t1 = {
      property,
      listingId
    };
    $[0] = listingId;
    $[1] = property;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    rows,
    selected,
    toggle
  } = useAssociateFieldsStep(t1);
  if (rows.length === 0) {
    return null;
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("fieldsTitle");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <p className="text-sm font-semibold text-foreground">{t2}</p>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("fieldsDescription");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <p className="text-sm text-muted-foreground">{t4}</p>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== rows || $[12] !== selected || $[13] !== toggle) {
    let t7;
    if ($[15] !== selected || $[16] !== toggle) {
      t7 = row => <CheckableFieldRow key={row.key} label={row.label} checked={selected.includes(row.key)} onCheckedChange={() => toggle(row.key)}><div className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-4"><FieldDiffValue text={row.from} pills={row.fromPills} /><ArrowRight className="size-4 shrink-0 text-muted-foreground" /><FieldDiffValue text={row.to} pills={row.toPills} emphasized={true} /></div></CheckableFieldRow>;
      $[15] = selected;
      $[16] = toggle;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    t6 = rows.map(t7);
    $[11] = rows;
    $[12] = selected;
    $[13] = toggle;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[18] !== t6) {
    t7 = <div className="mt-4 flex flex-col divide-y divide-border">{t6}</div>;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t3 || $[21] !== t5 || $[22] !== t7) {
    t8 = <div className="flex flex-col gap-1 border-t border-border pt-6" data-sentry-component="AssociateFieldsStep" data-sentry-source-file="AssociateFieldsStep.tsx">{t3}{t5}{t7}</div>;
    $[20] = t3;
    $[21] = t5;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}